import * as React from "react";
import { forwardRef } from "react";
const SvgLeftCube = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Property 1=24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M22 7V6L12 0L2 6V18L12 24L22 18V7ZM5.1 6.5L12 2.3L18.9 6.5L12 10.7L5.1 6.5ZM20 16.9L13 21.1V12.4L20 8.2V16.9Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgLeftCube);
export default ForwardRef;
